import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import logo from "../../images/Logo.svg";
import logolong from "../../images/LogoLong.svg";
import strings from "../../data/strings";

import { useScrollContext } from "../organisms/Scrollprovider";

import "./Navbar.css";

const Navbar: React.FC = () => {
  const [navActive, setNavActive] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { setShouldScroll } = useScrollContext();
  const navigate = useNavigate();

  const changeBackground = () => {
    if (window.scrollY > 50) {
      setNavActive(true);
    } else if (!menuOpen) {
      setNavActive(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  });

  const handleMenuToggle = () => {
    const newMenuOpen = !menuOpen;
    setMenuOpen(newMenuOpen);

    // Ensure nav is active when menu is open
    if (newMenuOpen) {
      setNavActive(true);
    } else {
      // If menu is closed, check scroll position to determine nav state
      if (window.scrollY <= 50) {
        setNavActive(false);
      }
    }
  };

  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShouldScroll(true);
    navigate("/");
  };

  const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return windowWidth;
  };

  const windowWidth = useWindowWidth();

  function goToTop(){
    window.scrollTo(0, 0);
    navigate("/");
  }

  return (
    <div id="navbar">
      <nav
        className={`${navActive ? "nav active" : "nav"} ${
          menuOpen ? "menu-open" : ""
        }`}
      >
        <Link to="/" className="logo">
          {windowWidth <= 900 ? (
            <img src={logolong} alt="Logo" />
          ) : (
            <img src={logo} alt="Logo" />
          )}
        </Link>

        <input
          className="menu-btn"
          type="checkbox"
          id="menu-btn"
          onChange={handleMenuToggle}
          checked={menuOpen}
        />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className="nav-icon"></span>
        </label>
        <ul className="menu">
          <li>
            <a href="/#" onClick={goToTop}>Ellie Care</a>
          </li>
          <li>
            <Link to={"/NuestrosPlanes"}>Planes</Link>
          </li>
          
          <li>
            <a href="#contact" onClick={handleContactClick}>
              Contactanos
            </a>
          </li>
          <li>
            <a href={`tel:${strings.phone_number_0800}`}>
              O llamanos al:
              <br />
              {strings.phone_number_0800}
            </a>
          </li>
          <li>
          <Link style={{backgroundColor: "#427E46", color: "#FFFFFF"}} to={"https://backoffice.elliecenter.com"}>Iniciar Sesión</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
